import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AimfoxLogoGradient from "assets/aimfoxLogos/aimfox-logo-gradient.svg?react";

export default function Heading() {
  const isDesktop = useTwBreakpoint("lg");

  if (isDesktop) {
    return (
      <div className="flex gap-x-5">
        <AimfoxLogoGradient className="size-[52px]" />

        <div>
          <span className="text-sm-bold">Welcome to Aimfox</span>
          <h3 className="text-3xl-bold mb-1">Your trial is live!</h3>
          <p className="text-sm-medium text-black-500">
            Enjoy 7 days of unlimited free trial, with full access to all
            features
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-2.5 items-center">
      <div className="flex gap-x-4">
        <AimfoxLogoGradient className="size-10" />

        <div>
          <span className="text-xs-medium">Welcome to Aimfox</span>
          <h3 className="text-xl-bold">Your trial is live!</h3>
        </div>
      </div>

      <p className="text-xs-medium text-center text-black-500">
        Enjoy 7 days of unlimited free trial, with full access to all features
      </p>
    </div>
  );
}
